import Vue from "vue";
import { ExStore } from "vuex";

interface ExVue extends Vue {
  $store: ExStore;
}

export function isOuterElementClicked(
  eventTarget: EventTarget | null,
  $innerTrigger: Element,
  $innerContent: Element
) {
  if (!eventTarget || !$innerTrigger || !$innerContent) {
    return false;
  }
  const isTriggerClicked =
    eventTarget instanceof Node && $innerTrigger.contains(eventTarget);
  if (isTriggerClicked) {
    return false;
  }
  const isContentClicked =
    eventTarget instanceof Node && $innerContent.contains(eventTarget);
  if (isContentClicked) {
    return false;
  }
  return true;
}
